import { useModel as _useModel, withAsyncContext as _withAsyncContext, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  class: "form-check",
  style: {"width":"260px"}
}
const _hoisted_3 = ["value", "onUpdate:modelValue", "id"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "onUpdate:modelValue", "aria-label"]
const _hoisted_6 = ["value"]

import {useAuditNoticeStore} from "@/stores/auditNoticeStore";
import {useAgencyContactsStore} from "@/stores/agencyContactsStore";

import {computed, ref, watch} from "vue";
import {Audit, AuditNotice, AuditNoticeOption} from "@/audit.types";
import {clone} from "@/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDetailsNotices',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue"], ["update:modelValue"]),
  async setup(__props: any, { emit: __emit }) {

let __temp: any, __restore: any

const model = _useModel<AuditNotice[]>(__props, "modelValue");

const props = __props;

const emit = __emit;

const auditNoticeStore = useAuditNoticeStore();
const agencyContactsStore = useAgencyContactsStore();

;(
  ([__temp,__restore] = _withAsyncContext(() => auditNoticeStore.list(props.id))),
  await __temp,
  __restore()
);
const items = ref<AuditNoticeOption[]>([]);
items.value = clone(auditNoticeStore.items);

;(
  ([__temp,__restore] = _withAsyncContext(() => agencyContactsStore.list(props.audit.ori))),
  await __temp,
  __restore()
);

const contacts = computed(() => agencyContactsStore.items);

watch(
    () => items,
    (newValue, oldValue) => {
        var value = items
            .value!.filter((opt) => opt.isSelected)
            .map(function (opt) {
                return {noticeId: opt.id, roleId: opt.roleId};
            });
        emit("update:modelValue", value);
    },
    {deep: true}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("fieldset", {
      style: {"max-width":"800px"},
      disabled: !__props.runAudits
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "d-flex mb-1 align-items-center"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: item.id,
              "onUpdate:modelValue": ($event: any) => ((item.isSelected) = $event),
              id: `notice_${item.id}`
            }, null, 8, _hoisted_3), [
              [_vModelCheckbox, item.isSelected]
            ]),
            _createElementVNode("label", {
              class: "form-check-label",
              for: `notice_${item.id}`
            }, _toDisplayString(item.action), 9, _hoisted_4)
          ]),
          (item.isSelected)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                id: `agencyContactRole_${item.id}`,
                "onUpdate:modelValue": ($event: any) => ((item.roleId) = $event),
                class: "form-select",
                "aria-label": `Contact role for ${item.action}`
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("option", { value: "0" }, "N/A - Send no emails", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value, (contact) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: contact.value,
                    key: contact.value
                  }, _toDisplayString(contact.label), 9, _hoisted_6))
                }), 128))
              ], 8, _hoisted_5)), [
                [_vModelSelect, item.roleId]
              ])
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 8, _hoisted_1)
  ]))
}
}

})